export type MeetingType = 'employee' | 'manager' | 'meeting'

export enum AppraisalContextType {
  Employee = 'employee',
  Manager = 'manager',
  Meeting = 'meeting',
}
